import React from "react";

import Heading from "@common/components/Heading/Heading";
import { Paragraph } from "@common/components/Paragraph/Paragraph.styles";

import * as Styled from "./ModuleDescriptionBox.styles";

export interface Props {
  title: string;
  subtitle: string;
}

export const ModuleDescriptionBox = ({ title, subtitle }: Props) => {
  return (
    <Styled.Container>
      <Heading marginBottom={10}>{title}</Heading>
      <Paragraph
        $lineHeight={28}
        $fontSize={20}
      >
        {subtitle}
      </Paragraph>
    </Styled.Container>
  );
};

export const FeedbackModuleDescriptionBox = () => {
  return (
    <ModuleDescriptionBox
      title={"Feedback"}
      subtitle={
        "Feedback collects every bug report, suggestion, and question your users send straight from the app — along with the device, OS, screen, and everything that happened leading up to it."
      }
    />
  );
};

export const CrashesModuleDescriptionBox = () => {
  return (
    <ModuleDescriptionBox
      title={"Crashes"}
      subtitle={
        "Crashes automatically captures every crash and app hang in your application, along with full context on the device, the user, and what they were doing in the minutes before it happened."
      }
    />
  );
};

export const UsersModuleDescriptionBox = () => {
  return (
    <ModuleDescriptionBox
      title={"Users"}
      subtitle={
        "Users shows every person using your app, with their info, ticket history, and a live chat — so you instantly see who's affected by a bug or crash and can reach out to them directly."
      }
    />
  );
};

export const ReleasesModuleDescriptionBox = () => {
  return (
    <ModuleDescriptionBox
      title={"Releases"}
      subtitle={
        "Releases scores every release you ship from 0 to 10, so you instantly know if it's safe to ship. The score is built from crash-free sessions, coverage, endpoints health, resolution rate, and more — all in one place."
      }
    />
  );
};
